import React from 'react';

import PropTypes from 'prop-types';
import { CONTACT_ERRORS } from 'constants/contact';
import { MODAL_TYPES } from 'constants/sequenceContact';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';

const ActionsPopover = (props) => {
  const { anchorEl, handleClose } = props;

  const toggleModal = (isOpen, whichModal, seqContact) => {
    props.toggleModal(isOpen, whichModal, seqContact);
    handleClose();
  };

  return (
    <Menu
      id="popover-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      {!props.seqContact.errors.some(err => err.error_type === CONTACT_ERRORS.BLACKLISTED) && (
        <MenuItem
          onClick={() => toggleModal(true, MODAL_TYPES.MOVE_MODAL, props.seqContact)}
        >
          Move to different sequence
        </MenuItem>
      )}
      <MenuItem
        onClick={() => toggleModal(true, MODAL_TYPES.REMOVE_MODAL, props.seqContact)}
      >
        Remove from campaign
      </MenuItem>
      {!props.seqContact.errors.some(err => err.error_type === CONTACT_ERRORS.BLACKLISTED) && (
        <MenuItem
          onClick={() => toggleModal(true, MODAL_TYPES.BLACKLIST_MODAL, props.seqContact)}
        >
          Do not contact
        </MenuItem>
      )}
      <MenuItem
        onClick={() => toggleModal(true, MODAL_TYPES.DELETE_MODAL, props.seqContact)}
      >
        Delete
      </MenuItem>
      {!props.seqContact.status_manually_finished_date &&
      <MenuItem
        onClick={() => toggleModal(true, MODAL_TYPES.MARK_AS_FINISHED_MODAL, props.seqContact)}
      >
        Mark as finished
      </MenuItem>}
      {props.seqContact.status_manually_finished_date &&
      <MenuItem
        onClick={() => toggleModal(true, MODAL_TYPES.UNMARK_AS_FINISHED_MODAL, props.seqContact)}
      >
        Unmark as finished
      </MenuItem>}
    </Menu>
  );
};


ActionsPopover.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  anchorEl: PropTypes.element,
  seqContact: PropTypes.shape({
    errors: PropTypes.element,
    status_manually_finished_date: PropTypes.string,
  }),
  handleClose: PropTypes.func.isRequired,
};

ActionsPopover.defaultProps = {
  anchorEl: null,
  seqContact: [],
};


export default ActionsPopover;
